import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=678ad826&scoped=true"
import script from "./CarouselCard.vue?vue&type=script&lang=js"
export * from "./CarouselCard.vue?vue&type=script&lang=js"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=678ad826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ad826",
  null
  
)

export default component.exports